import cn from 'classnames';

import { IConDefaultType } from '..';

export enum CheckLargeIconVariant {
  LINE = 'line',
  OFF = 'off',
  ON = 'on',
}

interface ICheckLargeIconProps extends IConDefaultType {
  variant?: CheckLargeIconVariant;
}

function CheckLargeIcon({
  color,
  className,
  size = 48,
  rotate,
  flip,
  variant = CheckLargeIconVariant.OFF,
}: ICheckLargeIconProps) {
  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        width: size,
        minWidth: size,
        height: size,
        transform: `rotate(${rotate}deg)`,
      }}
    >
      {variant === CheckLargeIconVariant.OFF && (
        <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="24" cy="24" r="18.5" stroke="#D8D8D8" strokeWidth="3" />
        </svg>
      )}
      {variant === CheckLargeIconVariant.LINE && (
        <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="24" cy="24" r="18.5" stroke="#303037" strokeWidth="3" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M33.0713 16.9501C33.6512 17.5418 33.6416 18.4915 33.0499 19.0713L21.6213 30.2713C21.0381 30.8429 20.1048 30.8429 19.5215 30.2713L14.9501 25.7913C14.3584 25.2115 14.3488 24.2618 14.9287 23.6701C15.5085 23.0784 16.4582 23.0688 17.0499 23.6487L20.5714 27.0998L30.9501 16.9287C31.5418 16.3488 32.4915 16.3584 33.0713 16.9501Z"
            fill="#303037"
          />
        </svg>
      )}
      {variant === CheckLargeIconVariant.ON && (
        <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="24" cy="24" r="20" fill="#00C3DD" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M33.0713 16.9501C33.6512 17.5418 33.6416 18.4915 33.0499 19.0713L21.6213 30.2713C21.0381 30.8429 20.1048 30.8429 19.5215 30.2713L14.9501 25.7913C14.3584 25.2115 14.3488 24.2618 14.9287 23.6701C15.5085 23.0784 16.4582 23.0688 17.0499 23.6487L20.5714 27.0998L30.9501 16.9287C31.5418 16.3488 32.4915 16.3584 33.0713 16.9501Z"
            fill="white"
          />
        </svg>
      )}
    </i>
  );
}

export default CheckLargeIcon;
